// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"58e8accf","330":"b811a841","515":"a92edc8b","558":"32442094","719":"7b2498ed","795":"5e7a316a","901":"f1675076"}[chunkId] + ".chunk.css";
};